const config = {
  logisticsUrl:
    process.env.REACT_APP_LOGISTICS_API_URL ||
    "https://stonelog.stone.com.br/api/gps",
  garagemToken: process.env.REACT_APP_GARAGEM_TOKEN,
  xavierToken: process.env.REACT_APP_XAVIER_TOKEN,
  header: "setHeader(Content-Type, application/json)",
  mapsKey: process.env.REACT_APP_MAPS_KEY,
  logToken: process.env.REACT_APP_STONELOG_TOKEN,
  hunterUrl:
    process.env.REACT_APP_HUNTER_API_URL ||
    "https://stonelog.stone.com.br/api/hunter",
  wsKey: process.env.REACT_APP_WS_URL,
  anyUrl: process.env.REACT_APP_ANY_URL,
  // Admin Stone Entrega exige a role perfil_liga. Fica LIGADO por padrão; só o valor exato
  // "false" desliga (build do HML, onde esse perfil não existe).
  requirePerfilLiga: process.env.REACT_APP_REQUIRE_PERFIL_LIGA !== "false",
};

export default config;
